var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "globalSettings" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.globalSettings") }],
            select: true,
          },
        },
        [
          _c(
            "a-button",
            {
              staticClass: "actionButtonBreadcrumb",
              on: { click: _vm.showModal },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.addSetting")))]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("a-table", {
                    staticClass: "custom-table2",
                    attrs: { columns: _vm.cols, dataSource: _vm.settings },
                    scopedSlots: _vm._u([
                      {
                        key: "value",
                        fn: function (setting) {
                          return _c("div", {}, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.settingsForm[setting._id],
                                  expression: "settingsForm[setting._id]",
                                },
                              ],
                              staticStyle: {
                                border: "none",
                                width: "100%",
                                background: "bottom",
                              },
                              attrs: {
                                placeholder: _vm.$t(
                                  "message.optionsPlaceholder"
                                ),
                              },
                              domProps: {
                                value: _vm.settingsForm[setting._id],
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.setSetting({
                                    id: setting._id,
                                    value: _vm.settingsForm[setting._id],
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.settingsForm,
                                    setting._id,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ])
                        },
                      },
                      {
                        key: "actionsSlot",
                        fn: function (setting) {
                          return _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex w-100 justify-content-center",
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    staticClass:
                                      "actionButton d-flex align-items-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteSetting(setting._id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-right": "16px",
                                          display: "block",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("message.delete")))]
                                    ),
                                    _vm._v(" "),
                                    _c("ActionDelete"),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass:
                                      "actionButton d-flex align-items-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editSetting(setting)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-right": "16px",
                                          display: "block",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("message.edit")))]
                                    ),
                                    _vm._v(" "),
                                    _c("ActionEdit"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.settings, function (setting) {
                return false
                  ? _c(
                      "b-col",
                      { key: setting._id, attrs: { sm: "4" } },
                      [
                        _c(
                          "md-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.deleteSetting(setting._id)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("message.delete")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.editSetting(setting)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("message.edit")))]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(setting.key))]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(setting.type))]),
                        _vm._v(" "),
                        _c(
                          "md-field",
                          [
                            _c("md-input", {
                              on: {
                                change: function ($event) {
                                  return _vm.setSetting({
                                    id: setting._id,
                                    value: _vm.settingsForm[setting._id],
                                  })
                                },
                              },
                              model: {
                                value: _vm.settingsForm[setting._id],
                                callback: function ($$v) {
                                  _vm.$set(_vm.settingsForm, setting._id, $$v)
                                },
                                expression: "settingsForm[setting._id]",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: { id: "addSettingFieldForm", "show-footer": false },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.saveHandle.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "global-settings-form" },
                    [
                      _c("h4", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.editMode
                                ? _vm.$t("message.changeSettings")
                                : _vm.$t("message.addNewSettings")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        {
                          class: {
                            "md-invalid":
                              _vm.errors.items.find(function (x) {
                                return x.field == _vm.$t("message.fieldName")
                              }) !== undefined,
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(" " + _vm._s(_vm.$t("message.fieldName"))),
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              name: _vm.$t("message.fieldName"),
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.modal.key,
                              callback: function ($$v) {
                                _vm.$set(_vm.modal, "key", $$v)
                              },
                              expression: "modal.key",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.fieldRequired", {
                                  field: _vm.$t("message.fieldName"),
                                })
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        {
                          class: {
                            "md-invalid":
                              _vm.errors.items.find(function (x) {
                                return x.field == _vm.$t("message.contentType")
                              }) !== undefined,
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(" " + _vm._s(_vm.$t("message.contentType"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-select",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                name: _vm.$t("message.contentType"),
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.modal.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.modal, "type", $$v)
                                },
                                expression: "modal.type",
                              },
                            },
                            _vm._l(
                              [
                                "string",
                                "number",
                                "boolean",
                                "array",
                                "object",
                              ],
                              function (t, i) {
                                return _c(
                                  "md-option",
                                  { key: i, attrs: { value: t } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        t.charAt(0).toLocaleUpperCase() +
                                          t.substr(1, t.length)
                                      ) + "\n                        "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.fieldRequired", {
                                  field: _vm.$t("message.contentType"),
                                })
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("label", [
                            _vm._v(" " + _vm._s(_vm.$t("message.value"))),
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            attrs: {
                              name: _vm.$t("message.value"),
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.modal.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.modal, "value", $$v)
                              },
                              expression: "modal.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "global-settings-submit md-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.save")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }